<div class="top-nav" [ngClass]="{
         'fixed': fixed,
         'navbg':addBg,
         'playPageNavBg': darkBg,
         'no-trans': noBgTransition,
         'playPage': ifPlayPage
        }">
  <div class="container">
    <div class="inner d-flex">
      <div class="box">
        <div class="d-flex h-100 align-items-center">
          <div class="logo d-flex align-items-center">
            <a routerLink="/" class="logo" title="{{siteName}} 首页">
              <img [src]="logoDark | safeResource" alt="{{siteName}}" width="200px" height="35px" />
              <img [src]="logoUrl | safeResource" class="img-pos" [ngClass]="{'i-hidden':isDark || lightMode_DarkLogo}"
                alt="{{siteName}}" width="200px" height="35px" />
            </a>
          </div>

          <app-dn-menu class="d-block position-relative nav-bar" [navType]="'navigation'"></app-dn-menu>
          <div class="multi-top-buttons">
            <ng-container *ngFor="let item of topNavButton">
              <div class="top-nav-btn" *ngIf="showDiscovery || item.title !== '发现'">
                <a href="{{ item.routerLink }}" class="d-flex align-items-center" target="_blank"
                  *ngIf="item.externalLink">
                  <div class="btn-text main-color" [ngClass]="{'grey-color':addBg}">{{ item.title }}</div>
                  <div class="top-nav-btn-new-icon" *ngIf="item.isNew">新</div>
                </a>
                <a [routerLink]="['/discovery']" class="d-flex align-items-center" *ngIf="!item.externalLink">
                  <div class="btn-text main-color" [ngClass]="{'grey-color':addBg}">{{ item.title }}</div>
                  <div class="top-nav-btn-new-icon" *ngIf="item.isNew">新</div>
                </a>
              </div>
            </ng-container>
          </div>
          <div class="margin-adjust outline" style="background-color:transparent"></div>
        </div>

      </div>
      <div class="box moveable">
        <div style="position: relative;">
          <app-dn-search-input></app-dn-search-input>
        </div>
      </div>

      <div class="box justify-content-end">
        <ng-container *ngIf="ifLottery">
          <div class="lottery-prize mr-2"
            (click)="enterLottery()">
            <div class="lottery-button fade-in" id="l-button" [style.background-image]="'url(' + randomPrize?.image + ')'"></div>
            <div class="lottery-prize-name" id="l-name">
              免费得
              <br>
              {{ randomPrize?.name }}
            </div>
          </div>
        </ng-container>
        <div *ngIf="ifInvite" id="inviteSvgaCanvas" class="invite-svgaplaybox" (click)="navToInvite()"></div>
        <app-dn-user-menu-item class="d-block h-100 top-item mx-2" [narrow]="true" [item]="rechargeMenuItem">
        </app-dn-user-menu-item>
        <app-daily-sign-in-button class="d-block h-100 top-item"></app-daily-sign-in-button>
        <div class="d-flex d-inline-flex top-item h-100 elementHoverable uploadtable mx-2" style="padding: 0 0.8em;">
          <div class="d-flex align-items-center uploader" title="上传" (click)="navToMyUpload()">
            <span class="iconfont iconyunshangchuan fs-32"></span>
            <span style="display: inline-block"></span>
          </div>

          <div class="upload-hover-box">
            <app-box-arrow [colorChange]="true"></app-box-arrow>
            <div class="upload-hover-ctn d-flex align-items-center justify-content-around">
              <div class="upload-btn d-flex flex-column align-items-center" [routerLink]="'/studio/svideo'"
                [queryParams]="{start:1}">
                <img class="upload-icon" src="{{'assets/images/user-center/shipin.png' | absUrl}}" loading="lazy">
                <div class="upload-title">
                  <span>
                    上传小视频
                  </span>
                </div>
              </div>
              <div class="upload-btn d-flex flex-column align-items-center" [routerLink]="'/studio/video'"
                [queryParams]="{start:1}">
                <img class="upload-icon" src="{{'assets/images/user-center/dianying.png' | absUrl}}" loading="lazy">
                <div class="upload-title">
                  <span>上传剧集</span>
                  <i class="iconbangzhu iconfont"></i>
                </div>
              </div>
              <div class="upload-btn d-flex flex-column align-items-center" [routerLink]="'/user/my-upload'"
                [queryParams]="{tag: 'activity'}">
                <img class="upload-icon" src="{{'assets/images/user-center/dongtai.png' | absUrl}}" loading="lazy">
                <div class="upload-title">
                  <span>
                    发布动态
                  </span>
                </div>
              </div>
              <div class="upload-btn d-flex flex-column align-items-center" [routerLink]="'/user/my-upload'"
                [queryParams]="{tag: 'album'}">
                <img class="upload-icon" src="{{'assets/images/user-center/xiangce.png' | absUrl}}" loading="lazy">
                <div class="upload-title">
                  <span>
                    管理相册
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <app-dn-user-menu></app-dn-user-menu>
        <div class="user-block d-flex d-inline-flex"></div>



      </div>

    </div>
  </div>
</div>
<div class="top-nav-shadow" [ngClass]="{'fixed': fixed,'navShadow':addBg}"></div>